'use client';
import { DocumentClient } from '@/common/model/apiClient';
import { useConfigStore } from '@/providers/ConfigStoreProvider';
import Link from 'next/link';
import { useIntl } from 'react-intl';
import styles from './DocumentCard.module.css';

interface DocumentCardProps {
  document: DocumentClient;
}

function DocumentCard(props: DocumentCardProps) {
  const doc = props.document;
  const selectedCurrency = useConfigStore((s) => s.currency);

  const intl = useIntl();
  return (
    <Link href={`/account/${doc.accountId}/document/${doc.id}`} className={styles.card}>
      <span className={styles.account}>{doc.account.name}</span>
      <div className={styles.title}>{doc.title}</div>
      <div>
        {doc.author.givenName} {doc.author.familyName} <span>({doc.author.email})</span>
      </div>
      {Number(doc.savingsTotal) > 0 && <div>{intl.formatNumber(Number(doc.savingsTotal), { style: 'currency', currency: selectedCurrency?.iso4217 })}</div>}
      <div></div>
    </Link>
  );
}

export default DocumentCard;
